import { createContext } from "react";

const EmpresaContext = createContext();

export default EmpresaContext;
